import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "+dTkmb",
    defaultMessage: "Live carts",
    description: "cart visibility page title",
  },
  subtitle: {
    id: "v6AQe+",
    defaultMessage: "{count} active {count, plural, one {cart} other {carts}}",
    description: "cart visibility page subtitle count",
  },
  searchPlaceholder: {
    id: "xA/zol",
    defaultMessage: "Search live carts...",
    description: "cart visibility search placeholder",
  },
});
